import axios from 'axios'

const TOKEN_KEY = 'toolbox_user_token'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api/toolbox',
  timeout: 30000
  // 不设默认 Content-Type，让 axios 根据请求数据类型自动判断：
  // 普通对象 → application/json
  // FormData → multipart/form-data（浏览器自动生成 boundary）
  // URLSearchParams → application/x-www-form-urlencoded
})

request.interceptors.request.use(config => {
  const token = getToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  window.localStorage.setItem(TOKEN_KEY, token)
}

export function clearToken() {
  window.localStorage.removeItem(TOKEN_KEY)
}

export { request }
